import axiosInterceptor from '../../interceptor/axiosClient';
import { codeForgotPasswordToken } from '../types';

export const codeForgotPassword = async (forgotPasswordData: codeForgotPasswordToken) => {
  const data = await axiosInterceptor.post('reset-password-confirm/', forgotPasswordData, {});

  return data.data;
};
